import { useEffect, useRef, useState } from 'react';
import FirmwareEdit from './FirmwareEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import { Space, Tag, Tooltip } from 'antd';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import dayjs from 'dayjs';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'firmware';

    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();
    const [familyData, setFamilyData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFetchData(() => ref.current.fetchData);
        }
        // 拉取固件家族编码（用于下拉筛选）
        fetchApi.GET(urlService, {
            query: {
                apiId,
                apiExtend: 'showPage',
                pageSize: 1000,
                pageIndex: 1
            }
        }).then(res => {
            if (res.success) {
                const list: any[] = res.data?.rows || res.data || [];
                const familySet = new Set<string>();
                list.forEach((it: any) => it?.family && familySet.add(it.family));
                setFamilyData([
                    { id: 'ALLITEM', name: '所有' },
                    ...Array.from(familySet).map(f => ({ id: f, name: f }))
                ]);
            }
        });
    }, []);

    // 表头
    const columnsHead = [
        {
            title: '固件名称',
            dataIndex: 'firmwareName'
        },
        {
            title: '编码',
            dataIndex: 'code'
        },
        {
            title: '家族',
            dataIndex: 'family'
        },
        {
            title: '版本',
            dataIndex: 'version'
        },
        {
            title: '文件大小',
            dataIndex: 'fileSize',
            render: (val: number) => {
                if (val === null || val === undefined) return '-';
                const n = Number(val);
                if (isNaN(n)) return '-';
                if (n < 1024) return `${n} B`;
                if (n < 1024 * 1024) return `${(n / 1024).toFixed(2)} KB`;
                return `${(n / 1024 / 1024).toFixed(2)} MB`;
            }
        },
        {
            title: '推荐版本',
            dataIndex: 'isRecommended',
            render: (val: boolean) =>
                val ? <Tag color="green">推荐</Tag> : <Tag>普通</Tag>
        },
        {
            title: '发布日期',
            dataIndex: 'releasedAt',
            render: (val: string) =>
                val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : '-'
        },
        {
            title: '更新说明',
            dataIndex: 'releaseNotes',
            render: (val: string) => val
                ? <Tooltip placement="topLeft" title={val}>
                    {val.length >= 10 ? val.substring(0, 10) + '......' : val}
                </Tooltip>
                : '-'
        },
        {
            title: '排序',
            dataIndex: 'sort'
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '固件',
        apiId,
        columns,
        serviceId: 'mf',
        editOptions: {
            Editor: FirmwareEdit
        }
    };

    return (
        <>
            <Space>
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='family'
                    getListData={familyData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                />
            </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    );
};

export default WebComponent;